module.exports = __webpack_public_path__ + "img/hardyFinish1.743e7b95.png";